export const AUTH_TOKEN = 'auth_token'
export const USER = 'user'
// export const imageUri = "https://leagueofchamps.s3.ca-central-1.amazonaws.com/"
export const imageUri = "https://leaguepro.s3.ca-central-1.amazonaws.com"
export const bucketUri = "https://leagueofchamps.s3.ca-central-1.amazonaws.com"